import { EducationLevelGroup } from 'src/constants';
import { CenterFormFields } from 'src/constants/centers';

// todo: fix this workaround after BE aligns with FE on the naming
export const EducationGroupOldToNewMap: Record<string, string> = {
    [EducationLevelGroup.PRESCHOOL]: CenterFormFields.BEFORE_SCHOOL_EDUCATION,
    [EducationLevelGroup.JUNIOR_SCHOOL]: CenterFormFields.FIRST_FOURTH_GRADE,
    [EducationLevelGroup.HIGH_SCHOOL]: CenterFormFields.FIFTH_TENTH_GRADE
};
